const PREFIX = "pl-bill-display-item";

export const PL_BILL_DISPLAY_ITEM_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
};
